// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

// Internal Dependencies
import GiftCard from './GiftCard/GiftCard';
import OverLoading from '../../../../components/Loading';
import { GiftType, Url } from '../../../../common/constants';
import ApiService from '../../../../services/apiService';
import FilterGift from './Gift/FilterGift';
import Colours from '../../../../styles/colours';
import MText from '../../../../components/Common/MText';
import RadioBtnSelect from '../../../../components/Common/RadioBtnSelect';
import { containerHeaderTextStyle } from '../../../../styles/common';

const List = (props) => {
  const history = useHistory();
  const pageId = props.page.id;

  const [gifts, setGifts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [giftType, setGiftType] = useState(GiftType.Coupon); // by default 'Coupon' gift type selected

  const order = { col: 'updatedAt', dir: 'DESC' };
  const pageSize = 5;
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [filterDescription, setFilterDescription] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  const [loading, setLoading] = useState(true);

  const addNewGiftHandler = async () => {
    try {
      setLoading(true);
      setIsModalOpen(false);

      const payload = {
        pageId,
        type: giftType,
      };

      const gift = await ApiService.createGift(pageId, payload);
      history.push(Url.Gift.replace(':pageId', pageId).replace(':giftId', gift.id));
    } catch (err) {
      console.log('Error in createGiftHandler: ', err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getGiftHandler = async () => {
    try {
      setLoading(true);

      const { rows, totalCount: totalGiftsCount } = await ApiService.getAllGifts(pageId, {
        pageNo: pageNo - 1, pageSize, order, label: filterDescription, type: filterType, status: filterStatus,
      });
      setGifts(rows);

      // Check if whole number. returns true otherwise false.
      if (Number.isInteger(totalGiftsCount / pageSize)) {
        setTotalPages(Math.floor(totalGiftsCount / pageSize));
      } else {
        // we add +1 from the total count for the remainder.
        setTotalPages(Math.floor(totalGiftsCount / pageSize) + 1);
      }

      setTotalCount(totalGiftsCount);
    } catch (err) {
      console.log('Error in getGiftHandler: ', err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateDescriptionFilter = (data) => setFilterDescription(data);

  const updateStatusFilter = (data) => setFilterStatus(data);

  const updateTypeFilter = (data) => setFilterType(data);

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => setIsModalOpen(false);

  const deleteGift = async (giftId) => {
    try {
      setLoading(true);
      await ApiService.deleteGift({ pageId, giftId });
      getGiftHandler();
      toast.success('Gift deleted successfully');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGiftHandler();
  }, [pageNo, filterDescription, filterType, filterStatus]);

  return (
    <div className="container-fluid">
      { loading && <OverLoading /> }
      <div className="row mb-3">
        <div className="col-12 d-flex flex-row align-items-center">
          <MText text="Coupons & Vouchers" size={containerHeaderTextStyle.fontSize} bold />
          {/* <MButton
            className="ml-2"
            text="+ Add"
            onClick={openModal}
            colour={Colours.Primary}
            textColour={Colours.White}
          /> */}
        </div>
      </div>

      {/** Commenting off the filter feature because it is causing the vertical scrolling to fail on the site */}
      {/* <FilterGift
        updateDescriptionFilter={updateDescriptionFilter}
        updateTypeFilter={updateTypeFilter}
        updateStatusFilter={updateStatusFilter}
      /> */}

      <div className="row mb-5 pb-5">
        {
          (!loading && totalCount === 0)
          && <MText className="ml-3" text="There is voucher at the moment. Please contact Monstyr to create a voucher." />
        }
        { gifts.map((gift) => <GiftCard key={gift.id} gift={gift} pageId={pageId} onDeleteGift={() => deleteGift(gift.id)} />) }
      </div>

      <div
        className="position-fixed ml-2 py-2 pr-3 d-flex flex-row align-items-center"
        style={{
          background:   Colours.White,
          bottom:       5,
          width:        '100%',
          borderRadius: '10px',
        }}
      >
        {totalCount > 0 && (
          <Pagination
            color="primary"
            size="large"
            count={totalPages}
            page={pageNo}
            defaultPage={1}
            onChange={(e, value) => setPageNo(value)}
            className="float-left"
          />
        )}
        <MText className="ml-3" text={`Total count: ${totalCount}`} />
      </div>

      <Dialog open={isModalOpen} fullWidth maxWidth="xs" onClose={closeModal}>
        <DialogContent>
          <MText text="Add Coupon / Voucher" bold size={16} />
          <MText text="Select Type" size={14} className="mt-3" />
          <RadioBtnSelect
            options={[
              { label: GiftType.Coupon, value: GiftType.Coupon },
              { label: GiftType.Voucher, value: GiftType.Voucher },
            ]}
            value={giftType}
            onChange={(value) => setGiftType(value)}
          />
        </DialogContent>

        <DialogActions>
          <Button clasName="px-4" onClick={() => closeModal()} color="primary" variant="text">Cancel</Button>
          <Button className="ml-3 px-4" onClick={() => addNewGiftHandler()} color="primary" variant="contained">Next</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  page: state.page.selected,
});

export default connect(mapStateToProps, null)(List);

List.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};
